@use "ui/styles/colors" as *;

$transition: 0.1s;

.wrapper {
  background-color: transparent;
  position: relative;
  display: flex;
  align-items: center;
  gap: 6px;
  width: fit-content;

  &.indeterminate {
    .icon {
      border-color: var(--secondary-text-color);
    }
  }

  &:hover:not(.disabled):not(.iconLock):not(.indeterminate) {
    .icon:not(.disabled) {
      border-color: var(--primary-color);
      background-color: var(--secondary-background-color);
    }

    .input:checked + .icon {
      border-color: var(--primary-color);
      background-color: var(--primary-color);
      opacity: 0.7;

      &:after {
        border-color: var(--background-color);
      }
    }
  }
}

.label {
  cursor: pointer;
  white-space: pre;

  &.disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
}

.icon {
  transition: all $transition;
  border-radius: 4px;
  cursor: pointer;
  height: 16px;
  width: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid var(--input-border-color);
  background-color: var(--background-color);
  position: relative;
  flex-shrink: 0;

  &:hover {
    border-color: var(--secondary-text-color);
    background-color: var(--secondary-background-color);
  }

  &:after {
    display: block;
    border: 2px solid var(--background-color);
    border-top: none;
    border-right: none;
    content: "";
    height: 5px;
    opacity: 0;
    position: absolute;
    top: 3.5px;
    left: 2.5px;
    transform: rotate(-50deg) scale(1.2);
    width: 9px;
  }
}

// Extra specificiity so it doesn't get overwritten
input[type="checkbox"].input {
  visibility: hidden;
  position: absolute;
  z-index: -1;

  &:checked + .icon:after {
    opacity: 1;
  }

  &:checked {
    & + .icon {
      border-color: var(--primary-color);
      background-color: var(--primary-color);
    }
  }
}

.iconLock * {
  cursor: default;
}

.disabled {
  input[type="checkbox"].input {
    &:checked {
      & + .icon {
        border-color: var(--input-border-color);
        background-color: var(--secondary-background-color);

        &:after {
          border-color: var(--secondary-text-color);
        }
      }
    }
  }

  .icon {
    cursor: not-allowed;

    &:hover {
      border-color: var(--input-border-color) !important;
      background-color: var(--secondary-background-color) !important;
    }
  }

  .label {
    cursor: default;
  }
}

.readOnly {
  .label,
  .icon {
    cursor: default;
  }

  .icon {
    background-color: transparent;
  }
}

.disabled,
.iconLock {
  .icon {
    border-color: var(--input-border-color);
    background-color: var(--secondary-background-color);
  }
}

.iconLock .icon:after {
  opacity: 0;
}

.partialCheck {
  .icon:after {
    border: none;
    height: 3px;
    opacity: 0;
    position: relative;
    top: unset;
    left: unset;
    transform: none;
    width: 80%;
    background-color: var(--background-color);
  }
}
